import { render, staticRenderFns } from "./dept_index.vue?vue&type=template&id=5b1e5649&scoped=true"
import script from "./dept_index.vue?vue&type=script&lang=js"
export * from "./dept_index.vue?vue&type=script&lang=js"
import style0 from "./dept_index.vue?vue&type=style&index=0&id=5b1e5649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e5649",
  null
  
)

export default component.exports